export default {
    state: {
        reports: [],
        options: []
    },

    getters: {
        getSigntureReports: state => state.reports,

        getSignatureOptions: state => state.options,
    },

    mutations: {

    },

    actions: {

    }
}
